import { Typography } from '@maia/ui';
import { ComponentPropsWithoutRef } from 'react';

export function A(props: ComponentPropsWithoutRef<'a'>) {
  return (
    <Typography
      as="a"
      variant="body-s"
      weight="regular"
      className="underline text-info300"
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      {props.children}
    </Typography>
  );
}
